const dirtyReasons = new Map<string, string>();

export function setOrganizationContextDirty(source: string, reason: string | null): void {
  if (reason) dirtyReasons.set(source, reason);
  else dirtyReasons.delete(source);
}

export function switchOrganizationContext(
  organizationId: string,
  assign: (url: string) => void = (url) => window.location.assign(url),
  confirm: (message: string) => boolean = (message) => window.confirm(message),
): boolean {
  if (dirtyReasons.size) {
    const details = [...new Set(dirtyReasons.values())].join("、");
    if (!confirm(`${details}。切换组织会丢失当前未保存内容，确定继续吗？`)) return false;
  }
  clearOrganizationContextStorage();
  assign(organizationId ? `/organizations/${encodeURIComponent(organizationId)}/projects` : "/organizations");
  return true;
}

export function clearOrganizationContextStorage(): void {
  for (let index = window.sessionStorage.length - 1; index >= 0; index -= 1) {
    const key = window.sessionStorage.key(index);
    if (key?.startsWith("organization-context:")) window.sessionStorage.removeItem(key);
  }
  window.sessionStorage.removeItem("active-organization");
  window.sessionStorage.removeItem("active-project");
  window.sessionStorage.removeItem("active-project-name");
}
